import React from "react";

function CashSalaryMobileIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="18"
			height="12"
			fill="none"
			viewBox="0 0 18 12"
		>
			<path
				fill="#8C8594"
				fillRule="evenodd"
				d="M.7 7.65v-6.3C.7.607 1.308 0 2.05 0h10.8c.743 0 1.35.607 1.35 1.35l-.007 6.3c0 .742-.6 1.35-1.343 1.35H2.05C1.308 9 .7 8.392.7 7.65zM4.075 1.5c0 1.035-.84 1.875-1.875 1.875v2.25c1.036 0 1.875.84 1.875 1.875h6.75c0-1.036.84-1.875 1.875-1.875v-2.25A1.875 1.875 0 0110.825 1.5h-6.75zM7.45 3a1.5 1.5 0 100 2.999 1.5 1.5 0 000-3zM3.7 11.25a.75.75 0 01.75-.75H15.7V3.75a.75.75 0 011.5 0v6.75a1.5 1.5 0 01-1.5 1.5H4.45a.75.75 0 01-.75-.75z"
				clipRule="evenodd"
			/>
		</svg>
	);
}

export default CashSalaryMobileIcon;
